import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { RegistryModel, Row } from 'shared/lib';

export type RegistryPaginationCounterProps = Omit<ComponentPropsWithoutRef<'div'>, 'children'>;

export const createRegistryPaginationCounter = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
>(
	model: RegistryModel<TRow, TFilters, TError>,
) => {
	const RegistryPaginationCounter = forwardRef<HTMLDivElement, RegistryPaginationCounterProps>(
		({ className, ...props }, ref) => {
			const { t } = useTranslation();

			const [current, total, hidden] = useUnit([
				model.page.$value,
				model.$totalPages,
				model.$paginationHidden,
			]);

			return (
				!hidden && (
					<div
						ref={ref}
						className={clsx('registry-pagination-counter', className)}
						{...props}
					>
						{t('registry.pagination-counter', { current: current + 1, total })}
					</div>
				)
			);
		},
	);

	return RegistryPaginationCounter;
};
